export const DataTables = {
  LOAN_DETAILS: "loan_details",
  TASK_DETAILS: "task_details",
  BANK_DETAILS: "bank_details",
  PERSONAL_DETAILS: "personal_details",
  PROFESSIONAL_DETAILS: "employment_details",
  EKYC_DATA: "ekyc_data",
  LENDER_LOAN_DETAILS: "lender_loan_details",
  INVOICE_DETAILS: "invoice_details",
  STUDENT_DETAILS: "student_details",
  LEAD: "lead",
  PRODUCT_DETAILS: "product_details",
  CLIENT_ACCOUNTS: "client_accounts",
  STAFF_CONFIG: "staff_config",
  FORM_SIXTY: "form_sixty_details",
  ASSOCIATED_ENTITIES: "associated_entities",
  CREDIT_ASSESSMENT_LOG: "credit_assessment_log",
};
